import React, { Fragment, useState } from "react";
import "./Styles.css";

import { useWindowWidth } from "@react-hook/window-size";
import { Link, useLocation } from "react-router-dom";

import EthosinoMobileSidebar from "../../../Sidebar";

const HeaderToMainPage = () => {
    const width = useWindowWidth();
    const [open, setOpen] = useState(false);

    const location = useLocation();
    const pathname = location.pathname;

    const isMobileNav = width < 980;

    const isActive = (path) => {
        if (path === "/") {
            return pathname === "/";
        }

        return pathname.startsWith(path);
    };

    return (
        <Fragment>

            {open && (
                <EthosinoMobileSidebar
                    toggled={open}
                    onClose={() => setOpen(false)}
                />
            )}

            <header className="eth-nav-v3">

                {/* =====================================================
            MICRO INFRASTRUCTURE BAR
        ===================================================== */}

                <div className="eth-nav-v3-topbar">

                    <div className="eth-nav-v3-shell eth-nav-v3-topbar-inner">

                        <div className="eth-nav-v3-platform-status">

                            <span className="eth-nav-v3-live-dot" />

                            <div>
                                <strong>
                                    ETHOSINO INFRASTRUCTURE
                                </strong>

                                <span>
                                    Operator platform online
                                </span>
                            </div>

                        </div>


                        {!isMobileNav && (
                            <div className="eth-nav-v3-utility">

                                <Link to="/request-documentation">
                                    Documentation
                                </Link>

                                <Link to="/company/architecture-walkthrough">
                                    Architecture
                                </Link>

                                <a
                                    href="https://demo.ethosino.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Live Environment
                                    <span>↗</span>
                                </a>

                            </div>
                        )}

                    </div>

                </div>


                {/* =====================================================
            MAIN NAVIGATION
        ===================================================== */}

                <div className="eth-nav-v3-main">

                    <div className="eth-nav-v3-shell eth-nav-v3-main-inner">

                        {/* LOGO */}

                        <Link
                            to="/"
                            className="eth-nav-v3-brand"
                        >
                            <img
                                src={require("../../../assets/images/logo.png")}
                                alt="Ethosino"
                            />
                        </Link>


                        {/* =================================================
                DESKTOP/TABLET NAV
            ================================================= */}

                        {!isMobileNav && (
                            <nav className="eth-nav-v3-navigation">

                                <ul className="eth-nav-v3-menu">

                                    {/* ===========================================
                      PLATFORM
                  =========================================== */}

                                    <li className="eth-nav-v3-item eth-nav-v3-has-dropdown">

                                        <button
                                            type="button"
                                            className="eth-nav-v3-link"
                                        >
                                            Platform

                                            <span className="eth-nav-v3-chevron">
                                                ⌄
                                            </span>
                                        </button>


                                        <div className="eth-nav-v3-dropdown eth-nav-v3-dropdown-wide">

                                            <div className="eth-nav-v3-dropdown-header">

                                                <div>
                                                    <span>
                                                        PLATFORM INFRASTRUCTURE
                                                    </span>

                                                    <strong>
                                                        Control the entire casino stack.
                                                    </strong>
                                                </div>

                                                <div className="eth-nav-v3-dropdown-status">
                                                    <i />
                                                    CORE SYSTEMS
                                                </div>

                                            </div>


                                            <div className="eth-nav-v3-dropdown-grid">

                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>01</span>

                                                        Core Infrastructure
                                                    </div>


                                                    <Link
                                                        to="/provably-fair-engine"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ◇
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Provably Fair Engine
                                                            </strong>

                                                            <span>
                                                                Cryptographic commitments and deterministic verification.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/info/multi-tenant/infrastructure"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ⬡
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Multi-Tenant Architecture
                                                            </strong>

                                                            <span>
                                                                One maintained platform, distinct operator environments.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/risk-management"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ⌁
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Risk & Exposure Controls
                                                            </strong>

                                                            <span>
                                                                Operator-side limits, oversight, and configuration.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>


                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>02</span>

                                                        Game & Control Layer
                                                    </div>


                                                    <Link
                                                        to="/table-games/engines"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ♠
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Table Game Engine
                                                            </strong>

                                                            <span>
                                                                Integrated wager execution and game-state infrastructure.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/originals-custom"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ✦
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Originals Framework
                                                            </strong>

                                                            <span>
                                                                Custom game systems running inside the Ethosino stack.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/comapny-core/fairness-tools"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ✓
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Fairness Tooling
                                                            </strong>

                                                            <span>
                                                                Player and operator-facing round inspection.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>

                                            </div>


                                            <div className="eth-nav-v3-dropdown-footer">

                                                <div>
                                                    <span>
                                                        PLATFORM PRINCIPLE
                                                    </span>

                                                    <strong>
                                                        Operator control. Player-verifiable evidence.
                                                    </strong>
                                                </div>

                                                <Link to="/company/architecture-walkthrough">
                                                    Explore Full Architecture
                                                    <span>→</span>
                                                </Link>

                                            </div>

                                        </div>

                                    </li>


                                    {/* ===========================================
                      SOLUTIONS
                  =========================================== */}

                                    <li className="eth-nav-v3-item eth-nav-v3-has-dropdown">

                                        <button
                                            type="button"
                                            className="eth-nav-v3-link"
                                        >
                                            Solutions

                                            <span className="eth-nav-v3-chevron">
                                                ⌄
                                            </span>
                                        </button>


                                        <div className="eth-nav-v3-dropdown eth-nav-v3-dropdown-medium">

                                            <div className="eth-nav-v3-dropdown-header">

                                                <div>
                                                    <span>
                                                        DEPLOYMENT MODELS
                                                    </span>

                                                    <strong>
                                                        Infrastructure adapted to the operator.
                                                    </strong>
                                                </div>

                                            </div>


                                            <div className="eth-nav-v3-dropdown-grid">

                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>01</span>

                                                        Operator Stage
                                                    </div>


                                                    <Link
                                                        to="/solutions/startup-operators"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ⚡
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Startup Operators
                                                            </strong>

                                                            <span>
                                                                Launch without rebuilding an entire casino stack.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>


                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>02</span>

                                                        Commercial Model
                                                    </div>


                                                    <Link
                                                        to="/solutions/sweepstakes"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ◈
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Sweepstakes Deployment
                                                            </strong>

                                                            <span>
                                                                Configurable dual-currency platform architecture.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>

                                            </div>


                                            <div className="eth-nav-v3-dropdown-footer">

                                                <div>
                                                    <span>
                                                        DEPLOYMENT
                                                    </span>

                                                    <strong>
                                                        Configure around your operating model.
                                                    </strong>
                                                </div>

                                                <Link to="/pricing">
                                                    View Licensing
                                                    <span>→</span>
                                                </Link>

                                            </div>

                                        </div>

                                    </li>


                                    {/* ===========================================
                      PRICING
                  =========================================== */}

                                    <li className="eth-nav-v3-item">

                                        <Link
                                            to="/pricing"
                                            className={`eth-nav-v3-link ${isActive("/pricing")
                                                ? "active"
                                                : ""
                                                }`}
                                        >
                                            Pricing
                                        </Link>

                                    </li>

                                    <li className="eth-nav-v3-item">

                                        <Link
                                            to="/docs"
                                            className={`eth-nav-v3-link ${isActive("/docs")
                                                ? "active"
                                                : ""
                                                }`}
                                        >
                                            Public Docs
                                        </Link>

                                    </li>
                                    {/* ===========================================
                      RESOURCES
                  =========================================== */}

                                    <li className="eth-nav-v3-item eth-nav-v3-has-dropdown">

                                        <button
                                            type="button"
                                            className="eth-nav-v3-link"
                                        >
                                            Resources

                                            <span className="eth-nav-v3-chevron">
                                                ⌄
                                            </span>
                                        </button>


                                        <div className="eth-nav-v3-dropdown eth-nav-v3-dropdown-medium">

                                            <div className="eth-nav-v3-dropdown-header">

                                                <div>
                                                    <span>
                                                        TECHNICAL RESOURCES
                                                    </span>

                                                    <strong>
                                                        Inspect the platform before you deploy it.
                                                    </strong>
                                                </div>

                                            </div>


                                            <div className="eth-nav-v3-dropdown-grid">

                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>01</span>

                                                        Product
                                                    </div>


                                                    <a
                                                        href="https://demo.ethosino.com"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ▶
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Live Casino
                                                            </strong>

                                                            <span>
                                                                Experience the player-facing platform directly.
                                                            </span>
                                                        </div>
                                                    </a>


                                                    <Link
                                                        to="/company/architecture-walkthrough"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ⌘
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Architecture Walkthrough
                                                            </strong>

                                                            <span>
                                                                See how the major infrastructure layers connect.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>


                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>02</span>

                                                        Documentation
                                                    </div>


                                                    <Link
                                                        to="/request-documentation"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ≡
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Request Documentation
                                                            </strong>

                                                            <span>
                                                                Technical and operator-facing platform materials.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/general/frequently-asked-questions"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ?
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                FAQ
                                                            </strong>

                                                            <span>
                                                                Commercial, technical, and deployment questions.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>
                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>03</span>

                                                        Terms/Conditions & Privacy Policy
                                                    </div>


                                                    <Link
                                                        to="/privacy/policy"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ?
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Privacy Policy
                                                            </strong>

                                                            <span>
                                                                View OUR Co. privacy policy
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/terms/and/conditions"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            ?
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Terms & Conditions
                                                            </strong>

                                                            <span>
                                                                View Ethosino's 'Terms & Conditions'
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>
                                            </div>

                                        </div>

                                    </li>


                                    {/* ===========================================
                      COMPANY
                  =========================================== */}

                                    <li className="eth-nav-v3-item eth-nav-v3-has-dropdown">

                                        <button
                                            type="button"
                                            className="eth-nav-v3-link"
                                        >
                                            Company

                                            <span className="eth-nav-v3-chevron">
                                                ⌄
                                            </span>
                                        </button>


                                        <div className="eth-nav-v3-dropdown eth-nav-v3-dropdown-small">

                                            <div className="eth-nav-v3-dropdown-grid">

                                                <div className="eth-nav-v3-dropdown-column">

                                                    <div className="eth-nav-v3-column-label">
                                                        <span>01</span>

                                                        Ethosino
                                                    </div>


                                                    <Link
                                                        to="/company"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            E
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                About Ethosino
                                                            </strong>

                                                            <span>
                                                                What we're building and why.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/company/careers"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            +
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Careers
                                                            </strong>

                                                            <span>
                                                                Help build the infrastructure layer.
                                                            </span>
                                                        </div>
                                                    </Link>


                                                    <Link
                                                        to="/book-demo"
                                                        className="eth-nav-v3-dropdown-link"
                                                    >
                                                        <div className="eth-nav-v3-drop-icon">
                                                            @
                                                        </div>

                                                        <div>
                                                            <strong>
                                                                Contact
                                                            </strong>

                                                            <span>
                                                                Talk directly about deployment.
                                                            </span>
                                                        </div>
                                                    </Link>

                                                </div>

                                            </div>

                                        </div>

                                    </li>

                                </ul>

                            </nav>
                        )}


                        {/* =================================================
                RIGHT SIDE
            ================================================= */}

                        <div className="eth-nav-v3-actions">

                            {!isMobileNav && (
                                <>
                                    <div className="eth-nav-v3-socials">

                                        <a
                                            href="https://www.instagram.com/ethosino_gaming"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Ethosino Instagram"
                                        >
                                            <img
                                                src={require("../../../assets/icons/instagram.png")}
                                                alt=""
                                            />
                                        </a>

                                        <a
                                            href="https://discord.gg"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="Ethosino Discord"
                                        >
                                            <img
                                                src={require("../../../assets/icons/discord.png")}
                                                alt=""
                                            />
                                        </a>

                                    </div>


                                    <a
                                        href="https://demo.ethosino.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="eth-nav-v3-sales-btn"
                                    >
                                        <div>
                                            <small>
                                                Demo
                                            </small>

                                            <strong>
                                                See product live
                                            </strong>
                                        </div>

                                        <span>
                                            →
                                        </span>
                                    </a>
                                </>
                            )}


                            {isMobileNav && (
                                <button
                                    type="button"
                                    className="eth-nav-v3-hamburger"
                                    onClick={() => setOpen(true)}
                                    aria-label="Open navigation"
                                >
                                    <span />
                                    <span />
                                    <span />
                                </button>
                            )}

                        </div>

                    </div>

                </div>

            </header>

        </Fragment>
    );
};

export default HeaderToMainPage;